module.exports = __webpack_public_path__ + "images/1831c8363fb50ca54bbb4caf9c063790.svg";